<template>
	<section class="section favourite-companies">
		<div class="container mx-auto">

      <search-sort :modelValue="searchSortData" :sortMenu="sortMenu" placeholder="Search Companies"></search-sort>

			<div class="org-cards">
				<template v-if="!me">
					<p>You must be signed in to see followed organisations</p>
				</template>
				<template v-else-if="!results">
					<p>Loading...</p>
				</template>
				<template v-else-if="computedFliteredCompanies.length == 0">
					<p>No organisations found</p>
				</template>
				<template v-else>
					<template v-for="(organisation, o) in computedFliteredCompanies" :key="o">
						<block-org-card :payload="organisation"></block-org-card>
					</template>
				</template>
			</div>
		</div>
	</section>
</template>

<script>
	import algoliasearch from 'algoliasearch';
	import AuthMixins from '@/mixins/AuthMixins';
  import SearchSort from './partials/SearchSort';

	export default {
		name: 'OrganisationsFollowed',

		mixins: [AuthMixins],

    components: {
      SearchSort
    },

		data() {
			return {
				org_ids: false,
        client: false,
				index: false,
				index_name: (this.$config.test_env) ? 'orgs-2023-test' : 'orgs-2023-live',
				searchObject: {
					hitsPerPage: 3,
					facets: ['org-main-id'],
					facetFilters: []
				},
				results: false,
        searchSortData: {search:'', sort:'title_asc'},
        sortMenu: [
          { title: 'Title Ascending', value: 'title_asc', selected: false },
          { title: 'Title Descending', value: 'title_desc', selected: false }
        ]
			}
		},

    created() {
			this.client = algoliasearch(this.$config.algolia.app_id, this.$config.algolia.app_key);
			this.index = this.client.initIndex(this.index_name);
		},

		mounted() {
			if (this.me) {
        this.loadData();
			}
		},

		methods: {
      loadData() {
       this.org_ids = this.me['saved-alerts'].filter(el => el['org-main-id'] !== '').map(el => el['org-main-id']);
       this.performSearch();
      },
      performSearch() {
        let temp = this.org_ids.map(el => `org-main-id:${el}`);
				this.searchObject.facetFilters.push(temp);
        this.searchObject.hitsPerPage = this.org_ids.length;

        this.index
          .search('', this.searchObject)
          .then((results) => {
            console.log("OrganisationsFollowed search raw results:", results);
            if (results.nbHits > 0) {
              this.results = results.hits;
            } else {
              this.results = false;
            }
          });
      },
      refreshFilters() {
        switch (this.searchSortData.sort) {
          case 'title_asc':
          this.results.sort((a, b) => a['org-name'].toLowerCase().localeCompare(b['org-name'].toLowerCase()));
            break;
          case 'title_desc':
          this.results.sort((a, b) => b['org-name'].toLowerCase().localeCompare(a['org-name'].toLowerCase()));
            break;
        }
      }
		},

    computed: {
      computedFliteredCompanies() {
        return this.results.filter(v => {
          return v['org-name'].toLowerCase().includes(this.searchSortData.search.toLowerCase());
        });
      }
    },

    watch: {
      searchSortData: {
        deep:true,
        handler() {
          this.refreshFilters();
        }
      }
    }
	}
</script>
